import React from "react";
import PhoneIcon from "../assets/images/phone-icon.svg";
import MailIcon from "../assets/images/mail.svg";

const Footer = ({ data }) => {
  if (!data) return null;

  const { logo, navigation, phone, mail } = data;

  return (
    <footer className="footer">
      <div className="flex-wrapper">
        <div className="flex-container">
          <a className="logo" href="/">
            <img src={logo?.url} alt="Domm Digital" />
          </a>
          <nav aria-label="Footer navigation">
            <ul className="navigation">
              {navigation?.map((item) => (
                <li key={item.id}>
                  <a href={item.url}>{item.label}</a>
                </li>
              ))}
            </ul>
          </nav>
          <div className="right-content">
            <a className="right-content__link" href={`mailto:${mail}`}>
              <img src={MailIcon} alt="mail-icon" />
              EMAIL
            </a>
            <a className="right-content__link" href={`tel:${phone}`}>
              <img src={PhoneIcon} alt="phone-icon" />
              PHONE
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
